var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"\n    tw-text-secondary\n    tw-cursor-pointer\n    tw-select-none\n    tw-font-medium\n    tw-inline-block\n  ",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }